import { Component } from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';

// The marketing chrome every public page shares. Pages that need the full
// viewport (e.g. the corporate dashboard) are routed outside this layout.
class SiteLayout extends Component {
    render() {
        return (
            <div className="App">
                <Navigation />
                <div className="container">
                    <section className="mt-4 mb-4">
                        <Outlet />
                    </section>
                </div>
                <Footer />
            </div>
        )
    }
}

export default SiteLayout;
